import { useState, useCallback } from "react";
import { message } from "antd";
import { detectColumnsFromFile, detectColumnsFromDb } from "../../../service/gateway.service";

/**
 * Manages source data selection (file upload or DB query),
 * column detection and auto-suggest mapping.
 */
export function useGatewaySource() {
  const [sourceType,     setSourceType]     = useState("CSV_UPLOAD");
  const [uploadedFile,   setUploadedFile]   = useState(null);
  const [dbName,         setDbName]         = useState("");
  const [sql,            setSql]            = useState("");
  const [sourceColumns,  setSourceColumns]  = useState([]);
  const [columnMappings, setColumnMappings] = useState([]);
  const [groupByColumn,  setGroupByColumn]  = useState("");

  const autoSuggest = useCallback((fieldDefs, srcCols) => {
    const suggestions = fieldDefs.map((f) => {
      let match = srcCols.find(
        (c) =>
          c.toLowerCase() === f.fieldName.toLowerCase() ||
          c.toLowerCase() === f.displayName.toLowerCase(),
      );
      if (!match)
        match = srcCols.find(
          (c) =>
            c.toLowerCase().includes(f.fieldName.toLowerCase().split("_")[0]) ||
            f.fieldName.toLowerCase().includes(c.toLowerCase().split("_")[0]),
        );
      return { sourceColumn: match || null, targetField: f.fieldName, transform: null, codeTableId: null };
    });
    setColumnMappings(suggestions);
  }, []);

  const onSourceConfirmed = async (fields, onSuccess) => {
    try {
      let cols = [];
      if (sourceType === "DB_QUERY") {
        const r = await detectColumnsFromDb(dbName, sql);
        cols = r.data || [];
      } else if (uploadedFile) {
        const r = await detectColumnsFromFile(uploadedFile);
        cols = r.data || [];
      } else {
        message.error("Upload a file or enter a SQL query");
        return;
      }
      setSourceColumns(cols);
      if (fields.length > 0) autoSuggest(fields, cols);
      onSuccess?.();
    } catch (e) {
      message.error("Could not detect columns: " + e.message);
    }
  };

  const resetSource = () => {
    setUploadedFile(null);
    setSql("");
    setSourceColumns([]);
    setColumnMappings([]);
    setGroupByColumn("");
  };

  return {
    sourceType, setSourceType,
    uploadedFile, setUploadedFile,
    dbName, setDbName,
    sql, setSql,
    sourceColumns,
    columnMappings, setColumnMappings,
    groupByColumn, setGroupByColumn,
    autoSuggest, onSourceConfirmed, resetSource,
  };
}
